import { useEffect, useState } from 'react';
import { clsx } from 'clsx';
import { DownloadIcon } from 'lucide-react';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from 'src/components/ui/dialog';
import { Button } from 'src/components/ui/button';

export const ExportKnowledgeBaseModal = ({
  disabled = false,
  className = '',
  handleExport,
}: {
  disabled?: boolean;
  className?: string;
  handleExport: (onSuccess: () => void, onError: (message: string) => void) => void;
}) => {
  const [open, setOpen] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');

  const closePopup = () => {
    setOpen(false);
  };

  const updateErrorMessage = (message: string) => {
    setErrorMessage(message);
  };

  const onClick = () => {
    handleExport(closePopup, updateErrorMessage);
  };

  useEffect(() => {
    if (open) {
      setErrorMessage('');
    }
  }, [open]);

  return (
    <Dialog onOpenChange={setOpen} open={disabled ? false : open}>
      <DialogTrigger disabled={disabled} asChild>
        <Button
          variant="ghost"
          type="button"
          className={clsx(
            'opacity-70 hover:opacity-100 transition-opacity flex flex-row gap-2 px-2',
            className,
          )}
        >
          Export Files
          <DownloadIcon width={16} />
        </Button>
      </DialogTrigger>
      <DialogContent closeButtonHidden>
        <DialogHeader>
          <DialogTitle>Export Knowledge Base</DialogTitle>
        </DialogHeader>
        <div className="pt-4 text-center">
          <p className={clsx('font-medium text-base', errorMessage ? 'text-error' : 'text-ebony')}>
            {errorMessage || 'Would you like to export Knowledge Base files?'}
          </p>
        </div>
        <div className="flex justify-center mt-5">
          {errorMessage ? (
            <Button variant="outline" type="button" className="min-w-24" onClick={closePopup}>
              Ok
            </Button>
          ) : (
            <div className="flex gap-2.5">
              <Button variant="outline" type="button" className="min-w-24" onClick={closePopup}>
                Cancel
              </Button>
              <Button className="min-w-24 gap-2" onClick={onClick}>
                Export
              </Button>
            </div>
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
};
